/* eslint-disable @nrwl/nx/enforce-module-boundaries */
/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';

import packageJson from '../../../../../../package.json';
import { environment } from '../../../../../../apps/web/src/environments/environment';

@Component({
  selector: 'midas-ui-app-version',
  templateUrl: './ui-app-version.component.html',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
})
export class UiAppVersionComponent {
  readonly version: string = packageJson.version;
  readonly releaseVersionDate: string = packageJson.versionDate;
  readonly environment = environment.production ? '' : environment.environment;
}
